// The promos/campaigns API returns a broader set of statuses (active, pending,
// expired, paused, rejected, ...) than the reward-ads UI understands
// (active/scheduled/completed) — map them down so status badges and filter
// pills stay meaningful.
const STATUS_MAP = {
  active: 'active',
  running: 'active',
  pending: 'scheduled',
  upcoming: 'scheduled',
  scheduled: 'scheduled',
  completed: 'completed',
  ended: 'completed',
  expired: 'completed',
  paused: 'completed',
  rejected: 'completed',
  cancelled: 'completed',
  failed: 'completed'
}

export function normalizeStatus(status) {
  return STATUS_MAP[(status ?? '').toLowerCase()] ?? 'completed'
}
